
import logo from "../../../assets/Logo/auth-logo.svg";
import { Link, useLocation } from "react-router-dom";
import widgetIcon from "../../../assets/Icons/seller/Widget 3.svg";
import boxIcon from "../../../assets/Icons/seller/delivery-box-01.svg";
import approveIcon from "../../../assets/Icons/seller/Vector.svg";
import orderIcon from "../../../assets/Icons/seller/package.svg";
import messageIcon from "../../../assets/Icons/seller/mail-01.svg";
import userIcon from "../../../assets/Icons/seller/User Rounded.svg";
import payIcon from "../../../assets/Icons/seller/invoice.svg";
import settingIcon from "../../../assets/Icons/seller/Vector.svg";
import { useQuery } from "@apollo/client";
import { List, ListItemButton, Skeleton } from "@mui/material";
import { COLORS } from "../../../STYLES/color";
import { GET_CURRENT_SUBSCRIPTION_PLAN } from "../../../Utils/Queries";

function formatPlanPrice(plan) {
  const amount = Number(plan?.price);
  if (!Number.isFinite(amount) || amount <= 0) return null;

  const currencyMap = { USD: "$", NGN: "₦", GBP: "£", EUR: "€" };
  const currency = currencyMap[plan?.currency] || plan?.currency || "$";
  const cycle = plan?.billingCycle ? `/${plan.billingCycle}` : "";
  return `${currency}${amount.toLocaleString("en-US")}${cycle}`;
}

function getPlanLimitText(plan) {
  const code = String(plan?.code ?? "").toLowerCase();
  const productLimit = Number(plan?.productLimit);

  if (code === "enterprise") return "Unlimited product listings available";
  if (Number.isFinite(productLimit) && productLimit > 0) {
    return `${productLimit.toLocaleString("en-US")} product listings available`;
  }
  return "10 product listings available";
}

function PlanUpgradeCard({ plan, subscription, loading }) {
  const planName = loading ? "Loading..." : plan?.name || "Free";
  const price = formatPlanPrice(plan);
  const status = subscription?.status;
  const linkText =
    String(plan?.code ?? "free").toLowerCase() === "free"
      ? "Upgrade Plan"
      : "Change Plan";

  return (
    <div className="mx-4 mb-6 rounded-[18px] bg-white px-4 py-5 shadow-[0_10px_28px_rgba(15,23,42,0.04)]">
      {
        loading ? (
<div>
  <Skeleton variant="text" sx={{width:'100%'}} height={20} />
  <Skeleton variant="text" sx={{width:'40%'}} height={20} />
  <Skeleton variant="text" sx={{width:'60%'}} height={20} />
  <Skeleton variant="text" sx={{width:'100%'}} height={50} />
</div>
        ):(
          <>
<p className="my-0 text-[12px] font-medium text-[#9898B0]">
        Current Plan
      </p>
      <p className="my-0 mt-1 text-[18px] font-bold leading-tight text-[#272727]">
        {planName}
      </p>
      {/* {price ? (
        <p className="my-0 mt-1 text-[12px] font-semibold text-[#2E1834]">
          {price}
        </p>
      ) : null} */}
      <p className="my-0 mt-1 text-[12px] leading-relaxed text-[#74767B]">
        {loading ? "Checking your subscription..." : getPlanLimitText(plan)}
      </p>
      {status ? (
        <span className="mt-3 inline-flex rounded-full bg-[#F0FAE5] px-3 py-1 text-[8px] font-bold uppercase tracking-[0.02em] text-[#115D31]">
          {status}
        </span>
      ) : null}
      <Link
        to="/seller/select-plan"
        state={{ from: "dashboard" }}
        className="-mt-3 flex h-[48px] items-center justify-center rounded-full bg-[#2E1834] text-[14px] font-bold text-white no-underline transition-colors hover:bg-[#3B2142]"
      >
        {linkText}
      </Link>
          </>
        )
      }
    </div>
  );
}

const Sidebar = () => {
  const router = useLocation();
  const { data, loading } = useQuery(GET_CURRENT_SUBSCRIPTION_PLAN, {
    fetchPolicy: "cache-and-network",
  });
  const currentPlan = data?.getCurrentSubscriptionPlan?.plan;
  const subscription = data?.getCurrentSubscriptionPlan?.subscription;

  return (
    <div
      className="flex h-full w-[240px] shrink-0 flex-col bg-[#F8F8F8]"
      style={{ borderRight: "1px solid #EAEAEA" }}
    >
      <div className="flex items-center justify-center">
        <Link to={"/seller/dashboard"}>
          <img src={logo} alt="Logo" width={120} className="m-4" />
        </Link>
      </div>

      <div className="mt-5 min-h-0 flex-1 overflow-y-auto px-4 pb-4">
        <List>
          {NAV_ITEMS.map((nav, id) => (
            <Link to={nav.route} key={id}>
              <ListItemButton
                selected={
                  id === 0
                    ? router.pathname === nav.route
                    : router.pathname.includes(nav.route)
                }
                sx={{
                  height: 40,
                  my: 2,
                  color: "#1515151",
                  " 	&.Mui-selected": {
                    borderRadius: "12px",
                    bgcolor: COLORS.PRIMARY_DARK,
                    borderLeft: "4px solid #2E1834",
                    fontWeight: 600,

                    "& > span ": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <img src={nav.icon} alt={nav.name} className="mr-3" />

                <span className="text-[#666666] text-[14px] line-clamp-1">
                  {nav.name}
                </span>
              </ListItemButton>
            </Link>
          ))}
        </List>
      </div>
      <PlanUpgradeCard
        plan={currentPlan}
        subscription={subscription}
        loading={loading}
      />
    </div>
  );
};

export default Sidebar;

export const NAV_ITEMS = [
  {
    name: "Dashboard",
    route: "/seller/dashboard",
    icon: widgetIcon,
  },
  {
    name: "My Products",
    route: "/seller/my-products",
    icon: boxIcon,
  },
  {
    name: "Product Approvals",
    route: "/seller/product-approvals",
    icon: approveIcon,
  },
  {
    name: "Orders",
    route: "/seller/orders",
    icon: orderIcon,
  },
  // {
  //   name: "Messages",
  //   route: "/chat",
  //   icon: messageIcon,
  // },
  {
    name: "Customers",
    route: "/seller/customers",
    icon: userIcon,
  },
  {
    name: "Payouts",
    route: "/seller/payouts",
    icon: payIcon,
  },
  {
    name: "System Settings",
    route: "/seller/settings",
    icon: settingIcon,
  },
];
